module.exports = __webpack_public_path__ + "static/media/NaniKidsFutsal.bd8c4ef2.mp3";